import {Component, EventEmitter, Output} from '@angular/core';
import {
  LIST_HELP_FLAG,
  LIST_HELP_ITEM,
  LIST_HELP_TYPE,
  ListHelpService
} from "../../shared/services/list-help/list-help.service";
import {Article} from "../../shared/models/article.model";
import {BoardService} from "../../shared/services/board/board.service";
import {OPTION_ITEM, OptionService} from "../../shared/services/option/option.service";
import {OPTION_TYPE} from "../../shared/defines/client.const";
import {api_url, api_url_replace} from "../../shared/defines/protocol";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";

@Component({
  selector: 'app-word-list-help',
  templateUrl: './word-list-help.component.html',
  styleUrls: ['./word-list-help.component.scss']
})
export class WordListHelpComponent {
  @Output() article = new EventEmitter<Article>();

  protected readonly LIST_HELP_TYPE = LIST_HELP_TYPE;
  protected readonly ApiUrl = api_url;
  protected readonly ApiUrlReplace = api_url_replace;

  public listHelp: Array<LIST_HELP_ITEM> | null = null;
  public articles = new Map<LIST_HELP_FLAG, Article>();

  constructor(
    private optionSvc: OptionService,
    private boardSvc: BoardService,
    private listHelpSvc: ListHelpService,
    private globalEventSvc: GlobalEventService,
  ) {
    this.reset();
  }

  public reset(): void {
    this.listHelp = this.listHelpSvc.GetListHelp(null);

    // HELP(게시판)이면 로딩을 해서 articles에 넣는다.
    const listBoard = this.listHelp.filter((item: LIST_HELP_ITEM) => item.type === LIST_HELP_TYPE.HELP)
      .map((item: LIST_HELP_ITEM) => item.content as number);
    if (listBoard.length > 0) {
      this.boardSvc.GetListIn(listBoard).subscribe((data: Article[]) => {
        console.log('WordListHelpComponent GetDetail=', data);
        const helpFlag = this.listHelp?.find((item: LIST_HELP_ITEM) => item.type === LIST_HELP_TYPE.HELP)?.flag;
        if (helpFlag !== undefined) {
          data.forEach((item: Article) => this.articles.set(helpFlag, item));
        } else {
          console.error('WordListHelpComponent GetDetail() helpFlag is undefined');
        }
      });
    }
  }

  GetOptionItem(type: OPTION_TYPE): OPTION_ITEM | null {
    return this.optionSvc.GetOptionItem(type);
  }

  public onSelectHelp($event: MouseEvent, item: LIST_HELP_ITEM): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event, true);

    const article = this.articles.get(item.flag);
    if (article) {
      this.article.emit(article);
    }
    else {
      console.error(`WordListHelpComponent onSelectHelp() article[${item.flag}] is undefined`);
    }
  }

  public onClose(item: LIST_HELP_ITEM, $event?: MouseEvent): void {
    console.log('onClose()', item);
    if ($event) {
      $event.stopPropagation();
      $event.preventDefault();
      this.globalEventSvc.Click($event, true);
    }

    this.listHelpSvc.SetFlag(item.flag);
    this.listHelp = this.listHelp?.filter(v => v.flag !== item.flag) ?? null;
  }
}
